import React from 'react';
import { Glyphicon,  Modal, Button } from "react-bootstrap";
import classes from './ModalConfirm.css';

const alert = (props) => {
    let confirmElement = null;
    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }
    confirmElement = 
        <div>
        <Modal show={props.showmodal} onHide={props.clickedCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Accreditamento portafoglio ePay sul sistema Ricariche</Modal.Title>
            </Modal.Header>
            <Modal.Body>Accreditare sistema ricariche per la matricola:{props.matricola}?</Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-secondary" onClick={props.clickedCancel}>
                    Annulla
                </Button>
                <Button className="btn btn-primary" onClick={props.clickedConfirm}>
                    Conferma
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
    return (
        <div className={classes.Input}>
            {confirmElement}
        </div>
    );
};

export default alert;